import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import { COLORS } from 'config'
import Icon, { ICON_CROSS } from 'components/common/Icon'
import Button from 'components/common/Button'

const Modal = props => {
  const {
    onClose,
    onOutClick,
    children,
    actions,
    cancellable,
    spaceBottom,
    spaceTop,
    embedded,
    width,
    transparent
  } = props

  return (
    <Div
      display="flex"
      position="absolute"
      zIndex={100}
      top={spaceTop ? '17.5%' : 0}
      bottom={spaceBottom ? '15%' : 0}
      left={0}
      right={0}
      alignItems="center"
      justifyContent="center"
      onClick={onOutClick}
    >
      <Div
        position="relative"
        width={width}
        borderRadius={transparent ? 0 : 18}
        backgroundColor={transparent ? 'transparent' : COLORS.white}
        boxShadow={!embedded && '0 0 20px rgba(0, 0, 0, 0.16)'}
        border={embedded && '1px solid rgba(0, 0, 0, 0.16)'}
        onClick={event => event.stopPropagation()}
        testId="inner"
      >
        {cancellable && (
          <Div position="absolute" right={6} top={6} width={36} height={36}>
            <Button onClick={onClose} padding={6} testId="close">
              <Icon width={24} height={24} path={ICON_CROSS} />
            </Button>
          </Div>
        )}

        {children}
        {actions}
      </Div>
    </Div>
  )
}

Modal.propTypes = {
  onClose: PropTypes.func,
  onOutClick: PropTypes.func,
  children: PropTypes.node,
  cancellable: PropTypes.bool,
  spaceBottom: PropTypes.bool,
  spaceTop: PropTypes.bool,
  embedded: PropTypes.bool,
  actions: PropTypes.arrayOf(PropTypes.element),
  width: PropTypes.number,
  transparent: PropTypes.bool
}

Modal.defaultProps = {
  onOutClick: () => {},
  onClose: () => {},
  actions: [],
  cancellable: true,
  width: 260,
  transparent: false
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/modal/Modal.js